export const messages = {
  en: {
    groupBuyManage: {
      searchConditions: 'Search Conditions',
      groupProductName: 'Group Product Name',
      batchNumber: 'Batch Number',
      orderNumber: 'Order Number',
      search: 'Search',
      reset: 'Reset',
      groupBuyList: 'Group Buy List',
      userId: 'User ID',
      userName: 'User Name',
      groupName: 'Group Name',
      groupId: 'Group ID',
      orderId: 'Order ID',
      groupCount: 'Group Count',
      paymentAmount: 'Payment Amount',
      status: 'Status'
    }
  },
  zh: {
    groupBuyManage: {
      searchConditions: '查询条件',
      groupProductName: '拼团商品名称',
      batchNumber: '批次编号',
      orderNumber: '订单号',
      search: '查询',
      reset: '重置',
      groupBuyList: '拼团列表',
      userId: '用户ID',
      userName: '用户名称',
      groupName: '拼团名称',
      groupId: '拼团ID',
      orderId: '订单号',
      groupCount: '拼团数量',
      paymentAmount: '付款金额',
      status: '状态'
    }
  }
}